'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CallToAction = require('shared/components/CallToAction');

var _MatchMe = require('shared/components/MatchMe');

var _HighlightedJobs = require('shared/components/HighlightedJobs');

var _Tutorial = require('shared/components/Tutorial');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'home';

var Home = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    (0, _classCallCheck3.default)(this, Home);
    return (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).apply(this, arguments));
  }

  (0, _createClass3.default)(Home, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          tagline = _props.tagline,
          icon = _props.icon,
          iconAlt = _props.iconAlt,
          callToActions = _props.callToActions,
          matchMe = _props.matchMe,
          location = _props.location;

      //const iconBankingCareer = require('shared/images/icons/icon-bank.png');
      //const jobImage = require('shared/images/stock/shutterstock01-small.png');

      return _react2.default.createElement(
        'section',
        { className: CLASS_NAME + ' page' },
        _react2.default.createElement(_Tutorial.TutorialOverlay, { loading: false, location: location }),
        _react2.default.createElement(
          'div',
          { className: 'hero homepage-hero' },
          _react2.default.createElement('img', { src: icon, alt: iconAlt }),
          _react2.default.createElement(
            'h1',
            null,
            title
          ),
          _react2.default.createElement(
            'h2',
            { className: 'tagline' },
            tagline
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'wrapper' },
          _react2.default.createElement(_CallToAction.CallToAction, {
            icon: callToActions[0].icon,
            iconAlt: callToActions[0].iconAlt,
            image: callToActions[0].image,
            imageAlt: callToActions[0].imageAlt,
            title: callToActions[0].title,
            subtext: callToActions[0].subtext,
            buttonAltSubtext: callToActions[0].buttonAltSubtext,
            link: callToActions[0].link
          }),
          _react2.default.createElement(_MatchMe.MatchMe, {
            title: matchMe.title,
            subtext: matchMe.subtext,
            buttonTitle: matchMe.buttonTitle,
            buttonSubtext: matchMe.buttonSubtext,
            buttonAltSubtext: matchMe.buttonAltSubtext,
            icon: matchMe.icon,
            iconAlt: matchMe.iconAlt,
            image: matchMe.image,
            imageAlt: matchMe.imageAlt,
            jobLimit: 20
          }),
          _react2.default.createElement(_CallToAction.CallToAction, {
            icon: callToActions[1].icon,
            iconAlt: callToActions[1].iconAlt,
            image: callToActions[1].image,
            imageAlt: callToActions[1].imageAlt,
            title: callToActions[1].title,
            subtext: callToActions[1].subtext,
            buttonAltSubtext: callToActions[1].buttonAltSubtext,
            link: callToActions[1].link
          }),
          _react2.default.createElement(_HighlightedJobs.HighlightedJobs, null)
        )
      );
    }
  }]);
  return Home;
}(_react.Component);

exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Home/Home.jsx
// module id = 1162
// module chunks = 0